import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	DndContext,
	closestCenter,
	PointerSensor,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import {
	SortableContext,
	verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { restrictToParentElement } from '@dnd-kit/modifiers';
import { IHomepageProfileNavItems, LanguagesAbbr } from '../../../../../../../types/working-model';
import { EventsState } from '../../../../../../../store/types';
import { updateHomepageProfileNav } from '../../../../../../../store/actions/admin/create-event';
import { GetDefaultProfileNavItems } from '../../../../../../../store/utils/create-event';
import SortableSessionNavItem from './sortable-nav-item';
import './event-main-navigation.scss';
import { useParams } from 'react-router';
import { ParamsProps } from '../../../../../../live-event/live-event';
import { getHomepageDefaultLanguage } from '../../../../../../../utils/get-language';

const ProfileNavigation: React.FC = () => {

	const workingEvent = useSelector((state: EventsState) => state.CreateEventReducer.workingEvent);

	const dispatch = useDispatch();
	const { language } = useParams() as ParamsProps;
	const baseLanguage = getHomepageDefaultLanguage() as LanguagesAbbr;

	const sensors = useSensors(
		useSensor(PointerSensor),
	);

	const navItems = useMemo(() => (
		workingEvent?.homepage?.event_profile_nav_items || GetDefaultProfileNavItems({ language, baseLanguage })
	), [workingEvent?.homepage?.event_profile_nav_items, language, baseLanguage]);

	function handleDragEnd(event: any) {
		const _profileNavItems = [...navItems];
		const startIndex = _profileNavItems.findIndex((navItem: IHomepageProfileNavItems) => navItem.name === event.active.id);
		const newIndex = _profileNavItems.findIndex((navItem: IHomepageProfileNavItems) => navItem.name === event.over.id);

		if (startIndex !== newIndex) {
			const [navItem] = _profileNavItems.splice(startIndex, 1);
			_profileNavItems.splice(newIndex, 0, navItem);
			// update database with updated items
			dispatch(updateHomepageProfileNav(_profileNavItems));
		}
	}

	const handleViewerClick = (navItem: IHomepageProfileNavItems) => {
		const _profileNavItems = navItems.map(ni => {
			if (ni.name === navItem.name) {
				return {
					...ni,
					is_on: !ni.is_on,
				};
			}
			return ni;
		});
		dispatch(updateHomepageProfileNav(_profileNavItems));
	};

	//Making static for now
	//Waiting on Product decisions on whether or not to make this titles editable here. They already exist in CTA form on the homepage. and this sends the data to a seperate place
	// const handleUpdateTitle = (value: string, navItem: IHomepageProfileNavItems) => {
	// 	// update name in redux and db
	// 	const _profileNavItems = navItems.map(ni => {
	// 		if (ni.name === navItem.name) {
	// 			return {
	// 				...ni,
	// 				custom_name: updateTranslateKey({
	// 					translateString: navItem.custom_name,
	// 					input: value,
	// 					baseLanguage: getHomepageDefaultLanguage(),
	// 					language
	// 				}),
	// 			};
	// 		}
	// 		return ni;
	// 	});
	// 	dispatch(updateHomepageProfileNav(_profileNavItems));
	// };

	return (
		<div className="event-main-navigation-container event-profile-menu-container">
			<div className="main-navigation-title">
				<h6>Profile menu</h6>
				{/* FUTURE DEV - buttons are not being implemented for MVP but will be used in the future */}
				{/* <div>
					<button
						className="no-style clear"
						onClick={() => ({})}
					>
						<Icon name={ICONS.EDIT} color={COLORS.CYAN} size={12} /> <span>Edit</span>
					</button>
					<button
						className="no-style clear"
						onClick={() => ({})}
					>
						<Icon name={ICONS.ADD} color={COLORS.CYAN} size={12} /> <span>Add page</span>
					</button>
				</div> */}
			</div>
			<DndContext
				sensors={sensors}
				collisionDetection={closestCenter}
				onDragEnd={handleDragEnd}
				modifiers={[restrictToParentElement]}
				autoScroll={false}
			>
				<SortableContext
					items={navItems.map((navItem: IHomepageProfileNavItems) => navItem.name)}
					strategy={verticalListSortingStrategy}
				>
					<div className="event-main-nav-items-container">
						{navItems!.map((navItem: IHomepageProfileNavItems) => (
							<SortableSessionNavItem
								key={navItem.name}
								navItem={navItem}
								id={navItem.name}
								handleViewerClick={handleViewerClick}
								// handleUpdateTitle={handleUpdateTitle}
								handleUpdateTitle={() => null}//Making static for now, waiting on product
								workingEvent={workingEvent!}
								notEditable //Making static for now, waiting on product
							/>
						))}
					</div>
				</SortableContext>
			</DndContext>
		</div>
	);
};

export default ProfileNavigation;
